export default {
  name: {
    id: 'rm_metal_zirconium_name',
    defaultMessage: 'Zirconium',
  },
  smartphoneLabel: {
    id: 'rm_metal_zirconium_smartphone_label',
    defaultMessage: 'Low (about a grain of rice)',
  },
  whatItDoesText: {
    id: 'rm_metal_zirconium_what_it_does',
    defaultMessage:
      'Zirconium oxide (ZrO₂) is used in ceramic substrates for surface-mount electronics and in some premium Android phone back panels. It offers high hardness, a smooth finish and complex manufacturing requirements.',
  },
  extractionText1: {
    id: 'rm_metal_zirconium_extraction_p1',
    defaultMessage:
      'Zirconium is recovered mainly from zircon (ZrSiO₄) found in heavy-mineral sands, and less commonly from baddeleyite (ZrO₂). Zircon is often recovered as a by-product of ilmenite and rutile mining. To produce nuclear-grade zirconium metal, the material is cracked, hafnium is removed, zirconium is converted into zirconium tetrachloride, then reduced and melted into metal.',
  },
  quickFactText: {
    id: 'rm_metal_zirconium_quick_fact',
    defaultMessage:
      'Demand for zirconium in selected clean-energy technologies could rise by 160% between 2025 and 2050.',
  },
  envSummaryText: {
    id: 'rm_metal_zirconium_env_summary',
    defaultMessage:
      'Zirconium mineral sands often contain naturally occurring radioactive materials (NORM), specifically thorium, requiring careful handling and disposal of mining residues. Co-extraction with titanium and rare earth elements in some deposits compounds radioactive waste management challenges.',
  },
  humanSummaryText: {
    id: 'rm_metal_zirconium_human_summary',
    defaultMessage:
      'Radioactive dust exposure from thorium co-extraction is a documented occupational health risk in mineral sands processing. Similar community and coastal ecosystem impacts to co-mined titanium. Zirconium compounds generally have low toxicity, but workers may face the general risks associated with mining and metallurgical processing, including dust, heavy machinery, accidents and chemical exposure. Naturally radioactive zircon residues also require appropriate monitoring and safeguards.',
  },
  geoSummaryText: {
    id: 'rm_metal_zirconium_geo_summary',
    defaultMessage:
      'Zirconium supply is linked to heavy-mineral-sands mining, which is primarily carried out for titanium minerals. Australia, South Africa and China are major producers of zircon sand, while the United States, France, China and Russia are the main producers of zirconium metal. Nuclear-grade zirconium requires hafnium separation, making its production more specialised. France supplied approximately 81% of EU zirconium metal imports, while the United States supplied 13%.',
  },
  geoDugText: {
    id: 'rm_metal_zirconium_geo_dug_text',
    defaultMessage:
      'Zirconium is mainly recovered from zircon-bearing mineral sands. In 2024, Australia accounted for approximately 33% of reported zirconium mineral concentrate production, followed by South Africa at 20% and Mozambique at 11%. Together, these countries represented approximately 64% of the rounded global total. These figures refer to zirconium mineral concentrates by gross weight, not refined zirconium metal.',
  },
  geoProcessedText: {
    id: 'rm_metal_zirconium_geo_processed_text',
    defaultMessage:
      'Average global zirconium metal production was approximately 6,000 tonnes per year between 2020 and 2024. The United States accounted for around 47%, followed by France at 21%, China at 20% and Russia at 12%.',
  },
  geoLeverageText: {
    id: 'rm_metal_zirconium_geo_leverage_text',
    defaultMessage:
      'The sources reviewed do not document zirconium-specific export restrictions.',
  },
  supplySummaryText: {
    id: 'rm_metal_zirconium_supply_summary',
    defaultMessage:
      'Supply is likely to meet current demand, but the market is exposed to disruptions and data uncertainty with declining zircon grades, rising production costs and geopolitical risks. Nuclear expansion and demand from aerospace, defence and automotive applications could increase pressure on a limited processing base.',
  },
  supplyReservesText: {
    id: 'rm_metal_zirconium_supply_reserves_text',
    defaultMessage:
      'USGS data report global zirconium reserves of more than 70 million tonnes of zirconium oxide content. Australia holds the largest reported reserves, followed by China, Madagascar, Mozambique, Senegal and South Africa. These figures concern zirconium-bearing minerals, not directly available reserves of refined zirconium metal.',
  },
  supplyDemandText: {
    id: 'rm_metal_zirconium_supply_demand_text',
    defaultMessage:
      'About 90% of zirconium metal is used in nuclear applications, especially fuel-rod cladding. Other uses include superalloys, aerospace, defence, space and chemical equipment. Demand for zirconium in selected clean-energy technologies is projected to rise by 160% between 2025 and 2050, driven by low-emissions power generation and hydrogen technologies.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_zirconium_recycling_summary',
    defaultMessage:
      'The estimated end-of-life recycling input rate is approximately 12%. Zirconium in ceramics, refractories, pigments and some alloys is generally difficult to recover, while clean zirconium metal scrap from rods, tubes, heat exchangers and alloys can be recycled. No reliable data are available on the amount of recycled zirconium used in new consumer electronics.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_zirconium_recycling_outlook_text',
    defaultMessage:
      'Not on its own. Recycling data are limited, and the sources do not describe a mature closed-loop system for recovering zirconium from smartphones. Primary production is therefore likely to remain necessary.',
  },
  footnote1Text1: {
    id: 'rm_metal_zirconium_footnote_1_p1',
    defaultMessage:
      'As Zirconium is not covered by the ADEME 2024 study, its environmental, social, geopolitical and supply-risk scores were calculated by Back Market’s Sustainability team using ADEME’s methodology, public sources and AI assistance. These scores carry greater uncertainty. See the Sources tab for the full methodology and references.',
  },
  mine0Region: {
    id: 'rm_metal_zirconium_mine0_region',
    defaultMessage: 'Eneabba',
  },
  mine1Region: {
    id: 'rm_metal_zirconium_mine1_region',
    defaultMessage: 'Richards Bay',
  },
  mine2Region: {
    id: 'rm_metal_zirconium_mine2_region',
    defaultMessage: 'Jacupiranga',
  },
  mine3Region: {
    id: 'rm_metal_zirconium_mine3_region',
    defaultMessage: 'North Stradbroke Island',
  },
  mine4Region: {
    id: 'rm_metal_zirconium_mine4_region',
    defaultMessage: 'Matam',
  },
  mine5Region: {
    id: 'rm_metal_zirconium_mine5_region',
    defaultMessage: 'Ceduna',
  },
  mine6Region: {
    id: 'rm_metal_zirconium_mine6_region',
    defaultMessage: 'Moma',
  },
  mine7Region: {
    id: 'rm_metal_zirconium_mine7_region',
    defaultMessage: 'Wenchang',
  },
} as const
